import { AnimatePresence, motion } from 'framer-motion'
import { AlertTriangleIcon } from 'lucide-react'
import React, { useEffect } from 'react'

interface NotificationProps {
  message: string | null
  onClose: () => void
}

const Notification: React.FC<NotificationProps> = ({ message, onClose }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(onClose, 5000)
      return () => clearTimeout(timer)
    }
  }, [message, onClose])

  return (
    <AnimatePresence>
      {message && (
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-4 right-4 bg-red-500 text-white p-4 rounded-md shadow-lg flex items-center space-x-2"
        >
          <AlertTriangleIcon className="w-6 h-6 mr-2" />
          {message}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default Notification
